<table *ngIf="onlineApprovalReport.length" class="layout-fixed striped">
  <colgroup>
    <col class="width-15" />
    <col class="width-15" />
    <col class="width-15" />
    <col class="width-45" />
  </colgroup>
  <thead>
    <tr>
      <th colspan="4">
        <h3 i18n="@@report.reportOnlineApprovals.titleApprovalDetails">Approval Details</h3>
      </th>
    </tr>
  </thead>
  <tbody class="secondary-header">
    <tr>
      <td class="text-center">{{StaticMessage.PriorityColumn | staticMessage}}</td>
      <td class="text-center" i18n="@@report.reportOnlineApprovals.colApprover">Approver</td>
      <td class="text-center" i18n="@@report.reportOnlineApprovals.colApprovalStatus">Approval Status</td>
      <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
    </tr>
  </tbody>
  <tbody>
    <tr *ngFor="let item of onlineApprovalReport; index as index">
      <td class="text-center accent">{{index + 1}}</td>
      <td class="text-center">{{item.approver}}</td>
      <td class="text-center">
        <span>
          <mat-icon
            [class]="'icon--' + (item.dprOnlineApproval | approveStatusColor : 'approveStatus')"
            class="icon-position mr-1"
            [svgIcon]="item.dprOnlineApproval | approveStatusIcon : 'approveStatus'"
          ></mat-icon>
          {{item.dprOnlineApproval | approveStatusText : customNames : 'approveStatus'}}
        </span>
      </td>
      <td>{{item.dprOnlineApproval.comment ?? '-'}}</td>
    </tr>
  </tbody>
</table>
